import { createTheme, createVariant, globalTheme } from '@clds/component-theme';
const { spacing, palette } = globalTheme;
export const tabsTheme = createTheme({
    solid: {
        tab: {
            verticalPadding: spacing.sm,
            horizontalPadding: spacing.sm,
            background: {
                color: {
                    base: palette.surfaceAlt,
                    active: palette.primary,
                    disabled: palette.surfaceAlt,
                },
            },
            focus: {
                color: palette.primary,
            },
            font: {
                color: {
                    base: palette.contrastLow,
                    hover: palette.primary,
                    active: palette.primary,
                    disabled: palette.contrastHigh,
                },
            },
        },
        layout: {
            fixed: {
                padding: spacing.xs,
            },
        },
        indicator: {
            color: palette.primary,
        },
        orientationVariant: {
            vertical: {
                tabContent: {
                    alignItems: 'start',
                },
            },
            horizontal: {
                tabContent: {
                    alignItems: 'center',
                },
            },
        },
    },
    thin: {
        tab: {
            verticalPadding: spacing.xxs,
            horizontalPadding: spacing.xs,
        },
    },
});
export const solidTabOrientationVariant = createVariant((props) => 
// eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
tabsTheme.solid.orientationVariant[props.orientation || 'horizontal']);
//# sourceMappingURL=TabsTheme.js.map